const initialState = {
  studentDetails: {}, // these go primarily in the sidebar
  wishlists: undefined,
  favorites: undefined,
  finalListDetails: undefined,
  surveyDetails: undefined,
  goals: undefined,
  taskActivities: undefined,
  studentPlans: {
    data: undefined,
  },
  planHistory: undefined,
  noteTags: undefined,
  notes: undefined,
  appManagerStats: undefined,
  collegeApplications: undefined,
  sectionPermissions: undefined,
  guardians: undefined,
  unclaimedGuardianContactInfos: [],
  schoolLists: undefined,
  favoriteSchools: undefined,
  finalListData: undefined,

  studentConversations: undefined,

  casefileTabs: [],
  guardianStudents: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'POPULATE_STUDENT_CASEFILE_TABS':
      return {
        ...state,
        casefileTabs: action.casefileTabs || [],
      };

    case 'POPULATE_STUDENT_CASEFILE_DETAILS':
      return {
        ...state,
        studentDetails: action.studentDetails || {},
      };
    case 'CLEAR_STUDENT_CASEFILE_DETAILS':
      return { ...state, studentDetails: {} };
    case 'POPULATE_PLAN_HISTORY':
      return {
        ...state,
        planHistory: action.planHistory,
      };
    case 'POPULATE_STUDENT_CASEFILE_FINAL_LIST': {
      return {
        ...state,
        wishlists: action.wishlists,
        favorites: action.favorites,
      };
    }
    case 'POPULATE_STUDENT_CASEFILE_FINAL_LIST_DETAILS': {
      return {
        ...state,
        finalListDetails: action.finalListDetails,
      };
    }
    case 'POPULATE_STUDENT_CASEFILE_GOALS':
      return {
        ...state,
        goals: action.goals,
      };
    case 'POPULATE_STUDENT_PLANS': {
      return {
        ...state,
        studentPlans: {
          ...state.studentPlans,
          data: action.data,
        },
      };
    }
    case 'POPULATE_STUDENT_CASEFILE_NOTE_TAGS': {
      return {
        ...state,
        noteTags: action.noteTags,
      };
    }
    case 'POPULATE_STUDENT_CASEFILE_NOTES': {
      return {
        ...state,
        notes: action.notes,
      };
    }
    case 'POPULATE_STUDENT_TASK_ACTIVITIES':
      return {
        ...state,
        taskActivities: action.tasks,
      };

    case 'POPULATE_CASEFILE_APP_MANAGER_STATS':
      return {
        ...state,
        appManagerStats: action.stats,
      };

    case 'UPDATE_CASEFILE_SECTION_PERMISSIONS':
      return {
        ...state,
        sectionPermissions: action.sectionPermissions,
      };

    case 'STUDENT_CASEFILE/POPULATE_GUARDIANS':
      return {
        ...state,
        guardians: action.guardians,
      };

    case 'STUDENT_CASEFILE/POPULATE_UNCLAIMED_GUARDIAN_CONTACT_INFOS':
      return {
        ...state,
        unclaimedGuardianContactInfos: action.unclaimedGuardianContactInfos,
      };

    case 'CASEFILE/POPULATE_FAVORITE_SCHOOLS':
      return {
        ...state,
        favoriteSchools: action.favoriteSchools,
      };

    case 'CASEFILE/POPULATE_SCHOOL_LISTS':
      return {
        ...state,
        schoolLists: action.schoolLists,
      };

    case 'STUDENT_CASEFILE/OPTIMISTIC_REASSIGN_DESIGNATION':
      return {
        ...state,
        finalListDetails: {
          ...state.finalListDetails,
          finalListItems: state.finalListDetails.finalListItems.map(item =>
            item.school.pk === action.schoolId
              ? { ...item, designation: action.designation }
              : item,
          ),
        },
      };

    case 'CASEFILE/POPULATE_STUDENT_CONVERSATIONS':
      return {
        ...state,
        studentConversations: action.studentConversations,
      };

    case 'CASEFILE/POPULATE_STUDENT_GPA':
      return {
        ...state,
        gpa: action.data,
      };

    case 'CASEFILE/POPULATE_ATTENDANCE_PERCENTAGE':
      return {
        ...state,
        attendancePercentage: action.data?.value,
      };

    case 'CASEFILE/POPULATE_GUARDIAN_STUDENTS':
      return {
        ...state,
        guardianStudents: action.students,
      };
    case 'CASEFILE/POPULATE_FINAL_LIST_DATA':
      return {
        ...state,
        finalListData: action.data,
      };

    default:
      return state;
  }
};
